import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'store';
import { GlobalStyle } from 'theme/GlobalStyle';
import history from 'utils/History';

import { routes } from 'routes/Routes';
import { ThemeProvider as MaterialUiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import { materialUiTheme } from 'theme/materialUiTheme';
import DailyPollPage from 'views/DailyPollPage/DailyPollPage';
import WelcomePage from 'views/WelcomePage/WelcomePage';
import RegisterPage from 'views/RegisterPage/RegisterPage';
import ThankYouPage from 'views/ThankYouPage/ThankYouPage';
import PrivacyPolicy from 'views/PrivacyPolicyPage/PrivacyPolicy';
import Unsubscribe from 'views/User/Unsubscribe/Unsubscribe';
import PageNotFound from 'views/PageNotFound/PageNotFound';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Successful from '../DailyPollPage/Successful';

const Root = () => {
    return (
        <>
            <Provider store={store}>
                <ThemeProvider theme={materialUiTheme}>
                    <MaterialUiThemeProvider theme={materialUiTheme}>
                        <GlobalStyle />
                        <ToastContainer />
                        <Router history={history}>
                            <Switch>
                                <Route exact path={routes.homeRoute} component={WelcomePage} />
                                <Route path={routes.registerRoute} component={RegisterPage} />
                                <Route path={routes.thankYouRoute} component={ThankYouPage} />
                                <Route path={routes.dailyPoll} component={DailyPollPage} />
                                <Route path={routes.dailyPollSuccessful} component={Successful} />
                                <Route
                                    exact
                                    path={routes.userUnsubscribe}
                                    component={Unsubscribe}
                                />
                                <Route path={routes.privacyPolicyRoute} component={PrivacyPolicy} />
                                <Route component={PageNotFound} />
                            </Switch>
                        </Router>
                    </MaterialUiThemeProvider>
                </ThemeProvider>
            </Provider>
        </>
    );
};

export default Root;
